// extracted by mini-css-extract-plugin
export var externalLink = "_80-0";
export var internalLinkLabel = "_80-1";